import React, { useEffect, useState } from 'react';
import { GenerateSSILink, GetSoftware } from 'api/software';
import { useQuery } from '@tanstack/react-query';
import { Card } from 'Components/Cards/card/card';
import { Link, useNavigate } from 'react-router-dom';
import LoadingIndicator from 'Components/Global/loading-indicator/loading-indicator';
import SharepointLink from 'Components/Global/SharepointLink/SharepointLink';
import CircularProgress from '@mui/material/CircularProgress';
import { StrikeThroughHeader } from 'Components/Headers/strikethrough-header/strikethrough-header';
import { XMasonry, XBlock } from 'react-xmasonry';
import { useUser } from '../../../../context/UserContext';
import FASTLink from '../../../../components/FASTLogineApp/FASTLink';
import Accordion from '@mui/material/Accordion';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './software-list.scss';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import RenderIcon from './RenderIcon';
import AdbOutlinedIcon from '@mui/icons-material/AdbOutlined';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import DownloadIcon from '@mui/icons-material/Download';

export default function SoftwareList() {
  const query = useQuery({
    queryKey: ['SoftwareList'],
    queryFn: () => GetSoftware()(),
  });

  if (query.isPending) {
    return (
      <>
        <StrikeThroughHeader>Software</StrikeThroughHeader>
        <LoadingIndicator />
      </>
    );
  }
  if (query.isError) {
    return (
      <>
        <StrikeThroughHeader>Software</StrikeThroughHeader>
        <div>Something went wrong.</div>
      </>
    );
  }
  if (query.isSuccess) {
    return <SoftwareListView data={JSON.parse(query.data)} />;
  }
}

function SoftwareListView({ data }) {
  const user = useUser();
  const navigate = useNavigate();
  let routePrefix = 'Applications';

  return (
    <>
      <StrikeThroughHeader>Software</StrikeThroughHeader>
      <XMasonry maxColumns={3} responsive targetBlockWidth={500}>
        {data !== null &&
          data.map((SoftwareCat) => (
            <XBlock key={SoftwareCat.CategoryName + SoftwareCat.ID}>
              <div className="m-2 software-list-wrapper">
                {SoftwareCat.SoftwareItems.length > 0 && (
                  // <Card
                  //     title={SoftwareCat.CategoryName ? SoftwareCat.CategoryName : 'Unnamed Software Group'}
                  //     height="auto"
                  //     headingFontColor="white"
                  //     headingHeight="3em"
                  //     width="100%"
                  // >
                  //     <ul>
                  //         {SoftwareCat.CategoryName === 'Secure Solutions Illustrator (Web Version)' && (
                  //             <SSILink id="SSI" label="Secure Solutions Illustrator (SSI)" />
                  //         )}
                  //         {SoftwareCat.SoftwareItems.map((softwareLink) => {
                  //             let returnElement;
                  //             switch (softwareLink.Title) {
                  //                 case 'Do Not Call':
                  //                       returnElement = (<li key={softwareLink.Title}><Link to={{ pathname: '/Software/DoNotCall' }}>{softwareLink.Title}</Link></li>);
                  //                   break;
                  //                 case 'Benefits Solution Proposal':
                  //                     if(user.permissions.WPM)
                  //                         returnElement = (<li key={softwareLink.Title}><Link to={{ pathname: '/Software/BenefitsSolutionProposal' }}>{softwareLink.Title}</Link></li>);
                  //                 break;
                  //                 case 'Weekly Agent Reports':
                  //                     if (user.division === "CASG")
                  //                         returnElement = (<li key={softwareLink.Title}><Link to={{ pathname: '/Software/WeeklyAgentReports' }}>{softwareLink.Title}</Link></li>);
                  //                     break;
                  //                 case 'App Package':
                  //                     returnElement = (<li key={softwareLink.Title}><Link to={{ pathname: '/Software/AppPackage' }}>{softwareLink.Title}</Link></li>);
                  //                     break;
                  //                 case 'Annuities, Generation Legacy, Lifetime Navigator - ULSG, Term, Whole Life':
                  //                     returnElement = (<SSILink id="Annuities" label="Annuities, Generation Legacy, Lifetime Navigator - ULSG, Term, Whole Life" />);
                  //                     break;
                  //                 case 'Application Download':
                  //                     returnElement = (<li key={softwareLink.Title}><Link to={{ pathname: '/Software/AppDownload' }}>{softwareLink.Title}</Link></li>);
                  //                     break;
                  //                 case 'iProvide INSpeed Plus eApp':
                  //                     returnElement = (<FASTLink id="FAST" />);
                  //                     break;
                  //                 default:
                  //                     returnElement = (<li key={softwareLink.Title}><SharepointLink link={softwareLink.LinkTypeID == 2 ? ("/Files/Software/" + softwareLink.Url) : softwareLink.Url}>{softwareLink.Title}</SharepointLink></li>);
                  //                     break;
                  //             }
                  //             return returnElement;
                  //         })}
                  //     </ul>
                  // </Card>
                  <Accordion defaultExpanded sx={{ backgroundColor: '#f2f2f2' }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                      // sx={{backgroundColor: '#0075BF'}}
                      className="software-list-accordien"
                    >
                      <span style={{ fontSize: '18px', fontWeight: 700, color: '#fff' }}>
                        {SoftwareCat.CategoryName
                          ? SoftwareCat.CategoryName
                          : 'Unnamed Software Group'}
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ul>
                        {SoftwareCat.CategoryName ===
                          'Secure Solutions Illustrator (Web Version)' && (
                          <SSILink id="SSI" label="Secure Solutions Illustrator (SSI)" />
                        )}
                        {SoftwareCat.SoftwareItems.map((softwareLink) => {
                          let returnElement;
                          switch (softwareLink.Title) {
                            // case 'Do Not Call':
                            //   returnElement = (
                            //     <li key={softwareLink.Title}>
                            //       <Link to={{ pathname: '/' + routePrefix + '/DoNotCall' }}>
                            //         <RenderIcon>
                            //           <PhoneDisabledIcon />
                            //         </RenderIcon>{' '}
                            //         {softwareLink.Title}
                            //       </Link>
                            //     </li>
                            //   );
                            //   break;
                            case 'Benefits Solution Proposal':
                              if (user.permissions.WPM)
                                returnElement = (
                                  <li key={softwareLink.Title}>
                                    <Link
                                      to={{
                                        pathname: '/' + routePrefix + '/BenefitsSolutionProposal',
                                      }}
                                    >
                                      <RenderIcon>
                                        <EmojiObjectsOutlinedIcon />
                                      </RenderIcon>{' '}
                                      {softwareLink.Title}
                                    </Link>
                                  </li>
                                );
                              break;
                            case 'App Package':
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <Link to={{ pathname: '/' + routePrefix + '/AppPackage' }}>
                                    <RenderIcon>
                                      <AppsOutlinedIcon />
                                    </RenderIcon>{' '}
                                    {softwareLink.Title}{' '}
                                  </Link>
                                </li>
                              );
                              break;
                            case 'Annuities, Generation Legacy, Lifetime Navigator - ULSG, Term, Whole Life':
                              returnElement = (
                                <SSILink
                                  id="Annuities"
                                  label="Annuities, Generation Legacy, Lifetime Navigator - ULSG, Term, Whole Life"
                                />
                              );
                              break;
                            case 'My Issued Apps (PDF)':
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <Link to={{ pathname: '/' + routePrefix + '/MyIssuedApps' }}>
                                    <RenderIcon>
                                      <TaskOutlinedIcon />
                                    </RenderIcon>
                                    {softwareLink.Title}
                                  </Link>
                                </li>
                              );
                              break;
                            case 'iProvide INSpeed Plus eApp':
                              returnElement = (
                                <FASTLink
                                  id={'FAST' + Math.floor(Math.random() * 10)}
                                  isShownICon={true}
                                  isBetween={false}
                                />
                              );
                              break;
                            case 'IQumulate eApplication':
                              returnElement = (
                                <FASTLink
                                  id={'FAST' + Math.floor(Math.random() * 10)}
                                  name="IQumulate eApplication"
                                  isShownICon={true}
                                  isBetween={false}
                                />
                              );
                              break;
                            case 'Product Illustration':
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <Link to={{ pathname: '/' + routePrefix + '/Proposal' }}>
                                    <RenderIcon>
                                      <LaunchOutlinedIcon />
                                    </RenderIcon>{' '}
                                    {softwareLink.Title}
                                  </Link>
                                </li>
                              );
                              break;
                            case 'Request Claimant Statement':
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <Link to={{ pathname: '/' + routePrefix + '/RequestClaimant' }}>
                                    <RenderIcon>
                                      <LaunchOutlinedIcon />
                                    </RenderIcon>{' '}
                                    {softwareLink.Title}
                                  </Link>
                                </li>
                              );
                              break;
                            case 'Secure File Delivery':
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <Link
                                    to={{ pathname: '/' + routePrefix + '/SecureFileDelivery' }}
                                  >
                                    <RenderIcon>
                                      <DownloadIcon />
                                    </RenderIcon>{' '}
                                    {softwareLink.Title}{' '}
                                  </Link>
                                </li>
                              );
                              break;
                            case 'Annual Statements':
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <Link to={{ pathname: softwareLink.Url }}>
                                    <RenderIcon>
                                      <DownloadIcon />
                                    </RenderIcon>{' '}
                                    {softwareLink.Title}{' '}
                                  </Link>
                                </li>
                              );
                              break;
                            default:
                              returnElement = (
                                <li key={softwareLink.Title}>
                                  <SharepointLink
                                    linkType={softwareLink.LinkTypeID}
                                    link={softwareLink.Url}
                                    baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/${routePrefix}`}
                                  >
                                    <RenderIcon>
                                      <LaunchOutlinedIcon />
                                    </RenderIcon>
                                    {softwareLink.Title}
                                  </SharepointLink>
                                </li>
                              );
                              break;
                          }
                          return returnElement;
                        })}
                      </ul>
                    </AccordionDetails>
                  </Accordion>
                )}
              </div>
            </XBlock>
          ))}
      </XMasonry>
    </>
  );
}

function SSILink({ ...props }) {
  const [ssiData, setSSIData] = useState(null);

  const SSIURL = useQuery({
    queryKey: ['SSILink', props.id],
    queryFn: () => GenerateSSILink({ azureID: '', envInput: '' })(),
    enabled: false,
    gcTime: 0,
  });

  useEffect(() => {
    if (SSIURL.isSuccess && SSIURL.data) {
      setSSIData(SSIURL.data);
    }
  }, [SSIURL.isSuccess, SSIURL.data]);

  const [errorTimer, setErrorTimer] = useState(false);

  useEffect(() => {
    if (ssiData?.postBackUrl) {
      document.forms['frmSSI' + props.id].submit();
    }
  }, [SSIURL.data]);

  useEffect(() => {
    if (SSIURL.isError) {
      setTimeout(() => {
        setErrorTimer(true);
      }, 3000);
    }
  }, [SSIURL.isError]);

  const openSSIURL = () => {
    SSIURL.refetch();
  };

  if (SSIURL.isError && !SSIURL.isFetching) {
    if (errorTimer) {
      return (
        <li>
          <a
            onClick={() => {
              openSSIURL();
            }}
          >
            <RenderIcon>
              <ReplayOutlinedIcon />
            </RenderIcon>{' '}
            Click to retry
          </a>
        </li>
      );
    }
    return (
      <li>
        <a>
          <RenderIcon>
            <LinkOffOutlinedIcon />
          </RenderIcon>
          Could not generate SSI Link
        </a>
      </li>
    );
  }

  return (
    <li>
      <a
        className="d-flex align-items-center"
        onClick={() => {
          openSSIURL();
        }}
      >
        <RenderIcon>
          <LaunchOutlinedIcon />
        </RenderIcon>{' '}
        {props.label}
        {SSIURL.isFetching && <CircularProgress size={16} />}
      </a>
      {SSIURL && (
        <form action={ssiData?.postBackUrl} id={'frmSSI' + props.id} target="_blank" method="POST">
          <input
            type="hidden"
            id="SAMLResponse"
            name="SAMLResponse"
            value={ssiData?.samlResponse}
          />
          <input type="hidden" id="RelayState" name="RelayState" value={ssiData?.relayUrl} />
        </form>
      )}
    </li>
  );
}
